import React from 'react';
import './Footer.css';  // Link to the Footer CSS file

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-text">
        </p>
      </div>
    </footer>
  );
}

export default Footer;
